import { Box } from "@mui/material";
import type { SxProps, Theme } from "@mui/material/styles";
import { alpha } from "@mui/material/styles";
import { gridClasses } from "@mui/x-data-grid-premium";
import { useCallback, useState } from "react";
import { createPortal } from "react-dom";
import InlineLoader from "@entrilia/shared/components/inlineLoader/InlineLoader.tsx";

// The grid sets its layout variables on the root element, so they resolve for a child portalled into it.
const loaderSx: SxProps<Theme> = {
  top: "var(--DataGrid-topContainerHeight)",
  bottom: "var(--DataGrid-bottomContainerHeight)",
  left: 0,
  right: 0,
  width: "auto",
  height: "auto",
  zIndex: 100, // above the grid's own layers, the highest being 70 for scrollbars
  bgcolor: (theme: Theme) => alpha(theme.palette.background.paper, 0.6),
};

const anchorSx: SxProps<Theme> = { display: "none" };

// Overlays live inside the horizontal scroller, sized to all columns, so only the root keeps the loader in view.
const GridLoadingOverlay = () => {
  const [rootElement, setRootElement] = useState<HTMLElement | null>(null);

  const handleAnchorRef = useCallback((anchor: HTMLDivElement | null) => {
    setRootElement(anchor?.closest<HTMLElement>(`.${gridClasses.root}`) ?? null);
  }, []);

  return (
    <Box ref={handleAnchorRef} sx={anchorSx}>
      {rootElement && createPortal(<InlineLoader overlay sx={loaderSx} />, rootElement)}
    </Box>
  );
};

export default GridLoadingOverlay;
